import { makeStyles } from '@material-ui/core';

export const useStyles = makeStyles({
  backdrop: {
    zIndex: 99999,
    color: '#fff',
  },
});
